import { EcommerceAPI } from "../Client";
import { appendProcessedFile } from "../../../utils/imageUploadProcessor";

export const getInventoryApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(`/inventory?id=${payload?.id || 0}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateInventoryApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(`/inventory`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postInventoryApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(`/inventory`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteInventoryApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(`/inventory?id=${payload?.id || 0}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postInventoryItemApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/inventory/item?inventoryId=${payload?.inventoryId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateInventoryItemApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(`/inventory/item`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteInventoryItemApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(
      `/inventory/item?inventoryItemId=${payload?.inventoryItemId || 0}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getInventorysApi = async () => {
  try {
    const response = await EcommerceAPI.get(`/inventorys`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getVendorApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(`/vendor?id=${payload?.id || 0}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateVendorApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(`/vendor`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postVendorApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(`/vendor`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteVendorApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(`/vendor?id=${payload?.id || 0}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postVendorLogoApi = async (payload) => {
  try {
    const formData = new FormData();
    await appendProcessedFile(formData, "file", payload.file);
    const response = await EcommerceAPI.post(`/vendor/logo`, formData, {
      headers: {
        "Content-Type":
          "multipart/form-data; boundary=----WebKitFormBoundaryTtTi35D4MiWOz5uq",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteVendorLogoApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(`/vendor/logo?key=${payload?.key || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getVendorsApi = async () => {
  try {
    const response = await EcommerceAPI.get(`/vendors`);
    return response;
  } catch (error) {
    throw error;
  }
};
